import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/fleet-task-request',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const get = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _get(queryParamFilters, queryParam, setParams, setMetadata)

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/fleet-task-request/${id}`,
  })

  return response?.data
}

export const transition = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/fleet-task-request/${id}/transition`,
    data,
  })

  return response?.data
}

export const bulkTransition = async (data) => {
  const response = await apiClientV2({
    baseURL: process.env.VUE_APP_API_BFF_URL,
    method: 'POST',
    url: `/fleet-task-request/transition`,
    data,
  })

  return response?.data
}